import { render } from "./IdMoneyField.vue?vue&type=template&id=5107743a&scoped=true"
import script from "./IdMoneyField.vue?vue&type=script&lang=js"
export * from "./IdMoneyField.vue?vue&type=script&lang=js"

import "./IdMoneyField.vue?vue&type=style&index=0&id=5107743a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5107743a"]])

export default __exports__